function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import * as COLORS from '../theme/colors';
import * as SCALE from '../theme/scale';
import { duration150, easeIn } from '../theme/animation';
const Wrapper = styled.div`
  background: ${({
  bgColor
}) => bgColor && COLORS[bgColor]};
  border-radius: ${({
  borderRadius
}) => borderRadius ? SCALE[borderRadius] : SCALE.size0};
  height: ${({
  height
}) => height ? SCALE[height] : SCALE.size4};
  width: 100%;
`;
const Progress = styled.div`
  background: ${({
  barColor
}) => barColor && COLORS[barColor]};
  border-radius: ${({
  borderRadius
}) => borderRadius ? SCALE[borderRadius] : SCALE.size0};
  height: 100%;
  transition: width ${duration150} ${easeIn};
  width: ${({
  $current,
  $max
}) => $current && $max && `${$current / $max * 100}%`};
`;
export const ProgressIndicator = ({
  currentStep,
  maxSteps,
  bgColor = 'orange50',
  barColor = 'orange400',
  borderRadius = 'size0',
  height = 'size4',
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    role: "progressbar"
  }, props, {
    borderRadius: borderRadius,
    height: height,
    bgColor: bgColor,
    "aria-valuemin": 0,
    "aria-valuenow": currentStep,
    "aria-valuemax": maxSteps,
    "aria-label": `Step ${currentStep} out of ${maxSteps}.`
  }), /*#__PURE__*/React.createElement(Progress, {
    $max: maxSteps,
    $current: currentStep,
    barColor: barColor,
    borderRadius: borderRadius
  }));
};
export default ProgressIndicator;
//# sourceMappingURL=index.js.map